import { createStore } from 'vuex'
import axios from 'axios';

export default createStore({
  state: {
    data: [],
    muted: true
  },
  mutations: {
    SAVE_DATA (state, data) {
      state.data = data;
    }, 

    TOGGLE_SOUND(state) {
      state.muted = !state.muted;
    }
  },
  getters: {
    data: state => state.data,
    getMuted: state => state.muted    
  },
  actions: {
    loadData ({ commit, state }) {
      return new Promise((resolve, reject) => { 
        if(state.data.length > 0) {
          resolve();
          return;
        }

        axios
          .get(process.env.VUE_APP_API)
          .then(result => {
            commit("SAVE_DATA", result.data);
            resolve();
          })
          .catch(error => {
            reject();
            throw new Error(`API ${error}`);
          });
      })
    },    

    toggleSound({ commit }) {
      commit("TOGGLE_SOUND");
    }
  },
  modules: {

  }
})
